<div class="wizzard-hints">
    <div class="wizzard-hints__inner">

        <div *ngIf="showAddUp$ | async" class="wizzard-hints__msg -default"
            [ngClass]="{'-has-error': hasError$ | async}">
            <span class="wizzard-hints__label">{{labelAdd}}</span>
            <span class="wizzard-hints__value -max-count">{{page.PageMaxQuantity}}</span>
        </div>

        <div *ngIf="showCounter$ | async" class="wizzard-hints__msg -counter"
            [ngClass]="{'-has-error': hasError$ | async}">
            <span class="wizzard-hints__value -current-count">{{wizzardPageTotalQuantity$ | async}}</span>
            <span class="wizzard-hints__sep">/</span>
            <span class="wizzard-hints__value -max-count">{{page.PageMaxQuantity}}</span>
        </div>

        <div *ngIf="showChooseMin$ | async" class="wizzard-hints__msg -default -choose"
            [ngClass]="{'-has-error': hasError$ | async}">
            <span class="wizzard-hints__label">{{labelSelect}}</span>
            <span class="wizzard-hints__value -min-count">{{page.PageMinQuantity}}</span>
        </div>

    </div>
</div>